import { useCallback, useState } from 'react'
import { StatusBar } from 'react-native'
import { useFocusEffect, useRouter } from 'expo-router'

import { translate } from '../../i18n'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../models'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { LeaderBoardView } from './LeaderBoardView'
import { LeaderboardPlayer } from '../../components/ANewDesign/LeaderboardList/LeaderboardList'

export const LeaderBoardScreen = observer(() => {
  const router = useRouter()
  const insets = useSafeAreaInsets()
  const {
    game: { getTournamentStats, setLeaderboardData, leaderboardData, myPlayer, players },
    communication: { clearCelebrations }
  } = useStore()
  const [loading, setLoading] = useState(true)

  useFocusEffect(
    useCallback(() => {
      ;(async () => {
        StatusBar.setBarStyle('light-content')
        setLoading(true)
        await getTournamentStats()
        setLoading(false)
      })()

      clearCelebrations()

      return () => setLeaderboardData(undefined)
    }, [getTournamentStats, setLeaderboardData, clearCelebrations])
  )

  const rawPlayers = leaderboardData?.players ?? []
  const myPlayerId = myPlayer?.id
  const myRankIndex = myPlayerId ? rawPlayers.findIndex((p) => p.playerId === myPlayerId) : -1
  const myRank = myRankIndex >= 0 ? myRankIndex + 1 : 0
  const prizePool = rawPlayers.reduce((sum, p) => (p.chips ? sum + p.chips : sum), 0)
  const leaderboardPlayers: LeaderboardPlayer[] = rawPlayers.map(p => ({
    playerId: p.playerId ?? '',
    playerName: p.playerName,
    isLeft: p.isLeft,
    isRemovedByTeacher: p.isRemovedByTeacher,
    chips: p.chips,
  }))

  return (
    <LeaderBoardView
      loading={loading}
      title={translate('leaderboard.leaderboardHeading')}
      onClose={() => router.navigate('/(root)/game')}
      paddingTop={insets.top}
      players={leaderboardPlayers}
      myPlayerId={myPlayerId}
      myRank={myRank}
      runTime={leaderboardData?.runTime ?? '00:00:00'}
      prizePool={prizePool}
    />
  )
})
